import React, { useEffect, useRef } from 'react';
import Header from '../common/Header';
import carrier from '../../assets/images/partners/carrier.jpg'
import unionaire from '../../assets/images/partners/unionaire.png'
import LG from '../../assets/images/partners/LG.jpg'
import { useLanguage } from '../../store/languageContext';
import { motion } from 'framer-motion'
import translate from '../../utils/translation';

const Advantages = () => {
    const sectionRef = useRef(null);
    const { language, setNavColor } = useLanguage();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setNavColor('black');
                }
            },
            {
                threshold: 0.1,
                rootMargin: '-50px 0px -20% 0px',
            }
        );

        const currentRef = sectionRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [setNavColor]);

    const advantages = [
        {
            number: '10',
            text: translate[language]['advantagesNumbers1']
        },
        {
            number: '1,500+',
            text: translate[language]['advantagesNumbers2']
        },
        {
            number: '4.9',
            text: translate[language]['advantagesNumbers3']
        },
    ];
    return (
        <section id='advantages' ref={sectionRef} className="container mx-auto landing-section px-4 sm:px-6">
            <div className='flex flex-col lg:flex-row lg:justify-between gap-6 lg:gap-0'>
                <Header text={translate[language]['advantagesHeader']} />
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.2, ease: 'easeOut' }}
                    viewport={{ once: true }}
                    className='flex justify-start lg:justify-end'>
                    <div className='inline font-semibold text-3xl sm:text-4xl md:text-5xl lg:text-[60px] leading-tight lg:leading-[60px]'>
                        {translate[language]['advantagesTitle1']}
                        <div className='flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4 mt-3' >
                            <span>
                                {translate[language]['advantagesTitle2']}
                            </span>
                            <span className={`inline-flex relative`}>
                                <div className={`w-12 h-12 sm:w-14 sm:h-14 md:w-[60px] md:h-[60px] bg-[#ccc] border-[3px] sm:border-[4px] border-white shadow-sm rounded-full overflow-hidden flex items-center justify-center z-[1] ${language === 'ar' ? 'translate-x-[-40%]' : 'translate-x-[40%]'}`}>
                                    <img src={carrier} alt='carrier' className='w-full' />
                                </div>
                                <div className={`w-12 h-12 sm:w-14 sm:h-14 md:w-[60px] md:h-[60px] bg-[#ccc] border-[3px] sm:border-[4px] border-white shadow-sm rounded-full overflow-hidden flex items-center justify-center z-[2] ${language === 'ar' ? 'translate-x-[-20%]' : 'translate-x-[20%]'}`}>
                                    <img src={unionaire} alt='unionaire' className='w-full' />
                                </div>
                                <div className={`w-12 h-12 sm:w-14 sm:h-14 md:w-[60px] md:h-[60px] bg-[#ccc] border-[3px] sm:border-[4px] border-white shadow-sm rounded-full overflow-hidden flex items-center justify-center z-[3]`}>
                                    <img src={LG} alt='LG' className='w-full' />
                                </div>
                                <div className={`w-12 h-12 sm:w-14 sm:h-14 md:w-[60px] md:h-[60px] bg-[#ccc] border-[3px] sm:border-[4px] border-white shadow-sm rounded-full overflow-hidden flex items-center justify-center z-[4] ${language === 'ar' ? 'translate-x-[20%]' : 'translate-x-[-20%]'}`}>
                                    <span className='text-lg sm:text-xl md:text-2xl'>
                                        +16
                                    </span>
                                </div>
                            </span>
                        </div>
                    </div>
                </motion.div>
            </div>
            <div className="mt-8 sm:mt-12">
                {advantages.map((advantage, index) => (
                    <motion.div
                        initial={{ y: (index + 1) * 100, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.5, delay: (index + 1) * 0.6, ease: 'easeOut' }}
                        viewport={{ once: true }}
                        key={index} className='border-b flex flex-col sm:flex-row justify-between items-start sm:items-end gap-2 sm:gap-4 pb-6 sm:pb-[30px] font-semibold'>
                        <span className='text-[#589EEE] text-6xl sm:text-8xl md:text-[120px] lg:text-[150px] leading-none sm:leading-[1]'>
                            {advantage.number}
                        </span>
                        <span className='uppercase text-sm sm:text-base md:text-lg self-end sm:self-auto'>
                            {advantage.text}
                        </span>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export { Advantages };